import { ArrowUpRight } from 'lucide-react'
import { Link } from 'react-router'
import { AnimatedButton } from '#app/components/ui/animated-button'
import { assets } from '#app/data/assets'
import { content } from '#app/data/content'

export default function FooterHeroSection() {
	const footer = content.shared.footer

	return (
		<section className="w-full">
			{/* HERO CTA */}
			{/* <div className="relative h-[628px]">
				<img
					src={assets.Footer.bannerImage}
					alt="City building"
					className="absolute inset-0 w-full h-full object-cover"
				/>

				<div className="relative z-10 h-full flex flex-col items-center justify-start text-center px-6 pt-[100px]">
					<h2 className="text-[#32302F] text-[25px] md:text-[45px] font-semibold mb-[30px] leading-tight">
						{footer.hero.title}
					</h2>

					<p className="text-[#32302F] text-[16px] md:text-[20px] max-w-[520px] mb-10">
						{footer.hero.description}
					</p>

					<AnimatedButton className="bg-white rounded-[52px] text-[18px] font-semibold text-[#32302F] hover:bg-white">
						{footer.hero.buttonText}
						<ArrowUpRight size={20} />
					</AnimatedButton>
				</div>
			</div> */}

			{/* FOOTER */}
			<footer className="bg-[#32302F] text-[#FFFFFF] overflow-x-hidden">
				<div className="mx-auto md:mx-[150px] px-4 md:px-0 py-16 grid gap-2 md:grid-cols-[4fr_1fr_1fr]">
					{/* LEFT COLUMN */}
					<div className="max-w-md pr-4 md:pr-0 flex flex-col items-center text-center md:items-start md:text-left">
						<img
							src={assets.Footer.logoImage}
							alt={footer.logoAlt}
							className="w-[70%] sm:w-[309px] mb-6 sm:mb-[61px]"
						/>

						<div>
							<p className="md:text-[35px] text-[20px] font-semibold mb-[29px]">
								{footer.newsletter.title}
							</p>

							<p className="mb-9 text-center mx-auto md:px-0 md:mx-0 md:text-left">
								{footer.newsletter.description}
							</p>

							<div className="flex w-full md:gap-4 gap-3 newsletter-row">
								<input
									type="email"
									placeholder={footer.newsletter.placeholder}
									className="flex-1 px-4 md:text-[18px] bg-transparent border border-[#FFFFFF] rounded-full placeholder:text-[#747474]"
								/>

								<AnimatedButton className="rounded-full bg-white text-[#32302F] md:text-[16px] font-semibold hover:bg-white">
									{footer.newsletter.buttonText}
									<ArrowUpRight size={20} />
								</AnimatedButton>
							</div>
						</div>
					</div>

					{/* DESKTOP MENUS */}
					{/* <div className="hidden md:block">
						<p className="font-semibold text-[18px] sm:text-[20px] md:text-[35px] mb-5 mt-24">
							{content.shared.footer.sectionTwo.title}
						</p>
						<ul className="space-y-3 text-[20px]">
							{footer.sectionTwo.pages.map((item) => (
								<li key={item}>{item}</li>
							))}
						</ul>
					</div>

					<div className="hidden md:block">
						<p className="font-semibold text-[35px] mb-5 mt-24 whitespace-nowrap">
							{content.shared.footer.sectionThree.title}
						</p>
						<ul className="space-y-3 text-[20px]">
							{footer.sectionThree.social.map((item) => (
								<li key={item}>{item}</li>
							))}
						</ul>
					</div> */}

					{/* MOBILE VIEW */}
					{/* <div className="grid grid-cols-2 gap-8 md:hidden mt-10 footer-columns">
						<div>
							<p className="font-semibold text-[25px] mb-4">
								{content.shared.footer.sectionTwo.title}
							</p>
							<ul className="space-y-2">
								{footer.sectionTwo.pages.map((item) => (
									<li key={item}>{item}</li>
								))}
							</ul>
						</div>

						<div>
							<p className="font-semibold text-[25px] mb-4">
								{content.shared.footer.sectionThree.title}
							</p>
							<ul className="space-y-2">
								{footer.sectionThree.social.map((item) => (
									<li key={item}>{item}</li>
								))}
							</ul>
						</div>
					</div> */}
				</div>

				{/* COPYRIGHT */}
				<div className="border-t border-[#FFFFFF] mx-6 md:mx-[150px] copyright-section">
					<div className="mx-auto py-5 md:px-0 flex flex-col md:flex-row gap-4 justify-between items-center text-[14px] md:text-[18px]">
						<p>{footer.copyright}</p>

						<div className="flex gap-6">
							<Link
								to="/terms"
								target="_blank"
								className="hover:text-white transition cursor-pointer"
							>
								{footer.legal.terms}
							</Link>
							<span>|</span>
							<Link
								to="/privacy"
								target="_blank"
								className="hover:text-white transition cursor-pointer"
							>
								{footer.legal.privacy}
							</Link>
						</div>
					</div>
				</div>
			</footer>
		</section>
	)
}
